import axios from '@/modules/axios/index';

const metaData = (key, file) => {
  return {
    id: key,
    storage: 'cache',
    metadata: {
      size: file.size,
      filename: file.name,
      mime_type: file.type
    }
  }
}

const getPreSignUrl = async () => {
  const result = await axios.get('/api/v1/admin/s3_params')
    .catch(() => {
      throw new Error('ファイルのアップロードに失敗しました');
    });

  return result.data;
}

export const uploadToS3 = async (file) => {
  if (file === '') throw new Error('ファイルを選択してください');

  const preSignUrlData = await getPreSignUrl();
  const headers = { 'Content-Type': 'multipart/form-data' };
  const params = new FormData();

  params.append('key', preSignUrlData.fields.key);
  params.append('policy', preSignUrlData.fields.policy);
  params.append('x-amz-credential', preSignUrlData.fields['x-amz-credential']);
  params.append('x-amz-algorithm', preSignUrlData.fields['x-amz-algorithm']);
  params.append('x-amz-date', preSignUrlData.fields['x-amz-date']);
  params.append('x-amz-signature', preSignUrlData.fields['x-amz-signature']);
  if(preSignUrlData.fields['x-amz-security-token']) {
    params.append('x-amz-security-token', preSignUrlData.fields['x-amz-security-token']);
  }
  params.append('file', file);

  await axios.post(preSignUrlData.url, params, { headers })
    .catch(() => {
      throw new Error('ファイルのアップロードに失敗しました');
    });

  return metaData(preSignUrlData.fields.key.match(/^cache\/(.+)/)[1], file);
}
